import {Listbox} from '@headlessui/react';
import {useState} from "react";
import Icon from '@mdi/react';
import {mdiCheck, mdiChevronDown} from '@mdi/js';
import Grid from "../Grid";
import GridItem from "../GridItem";
import {br, cl, icon, pad, pop, ring} from '../theme';
import Card from "../Card";
import {stop} from '../../../app/editor/utils/dom';
import cx from '../../../app/editor/utils/makeCls';
import {calculatePosition} from '../Tooltip';
import LabelField from '../LabelField';
import {usePopper} from 'react-popper';


const getById = (options, id) => {
    return options.filter(o => o.id === id)[0] || null;
}

const isSelected = (option, selected) => option?.id === selected?.id;

const isMatch = (opt, value) => {
    return opt.label.toLowerCase().indexOf(value.toLowerCase()) >= 0
};

const getPosValues = (open, refBtnEl, refPanelEl) => {
    const {innerHeight} = window;
    const style = open && refBtnEl && refPanelEl ?
        calculatePosition(refBtnEl, refPanelEl, {position: {y: 'bottom'}}) : {};
    return {
        ...style,
        minWidth: refBtnEl?.offsetWidth || 0,
        ...(refPanelEl && (refPanelEl.scrollHeight > innerHeight) ? {height: innerHeight} : {})
    };
}

export const optionsClassName = cx(
    'cursor-default select-none focus:outline-none',
    'z-20 max-h-full',
);

export const selectPopperOptions = {
    strategy: 'fixed',
    placement: 'bottom',
    modifiers: [
        {
            name: 'offset',
            options: {offset: [0, 5]},
        },
        {
            name: 'flip',
            options: {fallbackPlacements: ['top']},
        },
    ],
};

export function SelectFieldItem(props) {
    const {option, active, selected} = props;
    const isSelectedAdd = props.isSelected?.() || true;

    return (
        <Grid items="center" className={cx([pad.xy, active && pop.bgH])}>
            <GridItem className="truncate" grow>{option.label}</GridItem>
            <GridItem className="pl-2">
                {isSelected(option, selected) && isSelectedAdd &&
                    <Icon className={cl.tA} path={mdiCheck} size={icon.s}/>}
            </GridItem>
        </Grid>
    )
}

export default function SelectField({
                                        value,
                                        onChange,
                                        onBlur,
                                        handlerSelected,
                                        label,
                                        options,
                                        includeEmpty,
                                        className,
                                        search,
                                        fixed,
                                        open,
                                        caret = mdiChevronDown,
                                        size = 'm',
                                        width = '',
                                        border,
                                        pos,
                                        emptyState = '- Select an option -',
                                    }) {
    const [refButton, setRefButton] = useState(null);
    const [refOptions, setRefOptions] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const {styles, attributes} = usePopper(refButton, refOptions, selectPopperOptions);
    const opts = [...options].filter(opt => search ? isMatch(opt, searchValue) : opt);
    const hasSearch = search && searchValue;
    const selected = (hasSearch && opts.length) ? opts[0] : getById(opts, value);
    const handleChange = (value) => onChange(value.id);
    const emptyOption = {id: null, label: emptyState};
    const selectedValue = selected ?
        (handlerSelected ? handlerSelected(selected) : selected.label) :
        (handlerSelected ? handlerSelected(emptyOption) : emptyState);
    includeEmpty && opts.unshift(emptyOption);

    const onKeyDown = (ev) => {
        const {value} = ev.target;
        const val = value.trim();
        // eslint-disable-next-line default-case
        switch (ev.key) {
            case 'Escape':
                onChange(null);
                break;
            case 'Enter':
                onChange((opts.length ? opts[0].id : val) || null);
                break;
            case ' ':
                stop(ev);
                break;
        }
    };
    const clsButton = cx('w-full text-left cursor-pointer', br.rnd, ring.focus);

    const handleBlur = () => {
        onBlur?.();
    }

    return (
        <Listbox value={selected} onChange={handleChange}>
            {({open: isOpen}) => {
                return (
                    <div className="relative w-full text-sm">
                        {
                            label &&
                            <Listbox.Label>
                                <LabelField as="span" size={size}>{label}</LabelField>
                            </Listbox.Label>
                        }
                        <Listbox.Button ref={setRefButton} className={clsButton}>
                            {
                                search ?
                                    <input autoFocus
                                           value={searchValue}
                                           className={cx(['w-full', br.rnd, ring.focus, pad.xyS])}
                                           onChange={ev => setSearchValue(ev.target.value)}
                                           onKeyDown={onKeyDown}
                                           onClick={stop}
                                           onBlur={handleBlur}
                                    />
                                    :
                                    <Card border={border} size={size} title={selectedValue} icon={caret} shadow={false}
                                          className={className} titleClass=""/>
                            }
                        </Listbox.Button>
                        {/* { <div className={'opacity-30 w-full h-full fixed inset-0 z-40 bg-black'}/> } */}
                        {/* <Transition show={isOpen} as={Fragment} {...ts}> */}
                        {/* <Listbox.Options static={open} className={clsOptions} style={getPosValues(isOpen, refBtn.current, refPanel.current)}> */}
                        <Listbox.Options static={open} className={optionsClassName} ref={setRefOptions}
                                         style={styles.popper} {...attributes.popper}>
                            <Card padding={false} className="h-full"
                                  style={{minWidth: `${refButton?.offsetWidth}px`, maxHeight: 200}}>
                                {
                                    !opts.length && search && search !== true &&
                                    <div className={pad.xy}>
                                        {search.empty}
                                    </div>
                                }
                                {opts.map((option, index) => (
                                    <Listbox.Option key={index} value={option}>
                                        {({active, selected: sel}) => (
                                            <Grid items="center" className={cx([pad.xy, active && pop.bgH])}>
                                                <GridItem className="truncate" grow>{option.label}</GridItem>
                                                <GridItem className="pl-2">
                                                    {isSelected(option, selected) && !hasSearch &&
                                                        <Icon className={cl.tA} path={mdiCheck} size={icon.s}/>}
                                                </GridItem>
                                            </Grid>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Card>
                        </Listbox.Options>
                        {/* </Transition> */}
                    </div>
                )
            }}
        </Listbox>
    );
}